import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { UserService } from '../../../user/services/user.service';
import { DependentService } from '../../../user/services/dependent.service';
import { RequestsService } from '../services/requests.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { Dependent, Address } from '../../../user/models/user-profile.model';

@Component({
  selector: 'app-medico-domicilio',
  imports: [
    CommonModule,
    FormsModule,
    MatRadioModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './medico-domicilio.component.html',
  styleUrl: './medico-domicilio.component.scss'
})
export class MedicoDomicilioComponent implements OnInit, AfterViewInit {
  selectedPatient = 'titular';
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  dependent: Dependent[] = [];
  addresses: Address[] = [];
  userProfile: any;
  contactoDeTelefono: string = '0';
  showAllAddresses = false;
  selectedAddress: any = null;

  get canRequestAssistance(): boolean {
    return this.addresses.length > 0 && this.selectedAddress !== null;
  }

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private dependentService: DependentService,
    private requestServ: RequestsService,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    this.loader.show();
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
    }
    this.getServiceContact();
    this.getDetailUser();
    
    this.dependentService.direccionActualizada$.subscribe(() => {
      this.getDetailUser();
    });
  }

  ngAfterViewInit() {
    const addressAdded = sessionStorage.getItem('addressAdded');
    if (addressAdded === 'true') {
      sessionStorage.removeItem('addressAdded');
      this.getDetailUser();
    }
  }

  private getServiceContact(): void {
    try {
      const contacts = JSON.parse(localStorage.getItem('servicesContact') || '[]');
      const clSubServicio = parseInt(this.route.snapshot.queryParams['clSubServicio']) || 224;
      const serviceContact = contacts.find((c: any) => c.clSubservicio === clSubServicio);
      this.contactoDeTelefono = serviceContact?.phone || '0';
    } catch {
      this.contactoDeTelefono = '0';
    }
  }

  getDetailUser() {
    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.userProfile = res;
          this.dependent = res.dependents;
          this.addresses = res.address;
          this.loader.hide();
        },
        error: (err) => {
          console.error('Error al obtener perfil', err);
          this.loader.hide();
        }
      });
    }
  }

  isSelected(value: string): boolean {
    return this.selectedPatient === value;
  }

  addNewDependent() {
    this.router.navigate(['add-dependiente'], { queryParams: { returnUrl: this.router.url } });
  }

  solicitar() {
    if (!this.canRequestAssistance) {
      return;
    }
    this.generateExpediente();
  }

  generateExpediente() {
    const solicitudData = localStorage.getItem('solicitudData');
    let servicio;
    
    if (solicitudData) {
      servicio = JSON.parse(solicitudData).servicio;
    } else {
      const params = this.route.snapshot.queryParams;
      servicio = {
        clServicio: params['clServicio'] || 4,
        clSubservicio: params['clSubServicio'] || 224,
        dsServicio: params['dsServicio'] || 'Asistencia Médica',
        dsSubServicio: params['dsSubServicio'] || 'Médico a Domicilio'
      };
    }
    
    this.loader.show();
    
    const selectedName = this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient;
    const { firstName, lastName, secondLastName } = this.splitFullName(selectedName);
    const { firstName: ownerFirstName, lastName: ownerLastName, secondLastName: ownerSecondLastName } = this.splitFullName(this.nameOwner);
    
    const accountData = localStorage.getItem('account');
    const accountId = accountData ? JSON.parse(accountData) : 536;
    
    const payload = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        serviceId: servicio.clServicio,
        subServiceId: servicio.clSubservicio.toString(),
        hasAssistance: false,
        key: this.keyOwner,
        areaCode1: '044',
        phone1: this.phoneOwner,
        stateCode: '',
        municipalityCode: '',
        statusId: 0,
        accountId: accountId,
        appUserId: 1,
        countryId: 115,
        contactTypeId: 15,
        serviceTypeId: 1,
        sendCharge: false,
        hasAppointment: false,
        isRelevant: false,
        gender: 1,
        isOk: true,
        hasQuotation: false,
        isSise2: true,
        serviceReceptionId: 10,
        personId: 1,
        username: firstName,
        paternalSurname: lastName,
        userSecondLastName: secondLastName,
        contactName: selectedName,
        userFirstNamePf: ownerFirstName,
        userLastNamePf: ownerLastName,
        userSecondLastNamePf: ownerSecondLastName,
        ourUser: this.nameOwner,
        externalCabRepName: 'API CLIENTES',
        folio: crypto.randomUUID(),
        longitude: this.selectedAddress?.lng?.toString() || '',
        latitude: this.selectedAddress?.lat?.toString() || '',
        incidentDescription: this.getSelectedAddressInfo(),
        clRecepcionServicio: 10,
        infoadicional: this.getSelectedAddressInfo(),
        callenum: this.getSelectedAddressInfo().substring(0, 99)
      }
    };

    this.requestServ.sendHomeDoctorRequest(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        console.log('Expediente generado:', res);
        
        const expediente = res?.response?.id || res?.data?.clExpediente || res?.clExpediente;
        
        const assistanceData = {
          clave: res.response.clave || '',
          clexpediente: expediente,
          nuestrousuario: res.response.nuestrousuario || this.nameOwner,
          clcuenta: res.response.clcuenta || '',
          nombre: 'MÉDICO A DOMICILIO',
          clservicio: res.response.clservicio || servicio.clServicio,
          dsservicio: servicio.dsServicio || 'Asistencia Médica',
          clsubservicio: res.response.clsubservicio || servicio.clSubservicio,
          dssubservicio: servicio.dsSubServicio || 'Médico a Domicilio',
          clestatus: res.response.clestatus || '0',
          dsestatus: 'Abierto',
          fecharegistro: res.response.fecharegistro || new Date().toISOString()
        };
        
        if (solicitudData) {
          localStorage.removeItem('solicitudData');
        }
        
        const navigationExtras: NavigationExtras = {
          state: assistanceData,
          queryParams: assistanceData
        };
        
        this.router.navigate(['/solicitud/detalle/', expediente], navigationExtras).then(() => {
          setTimeout(() => {
            this.goToCall();
          }, 1000);
        });
      },
      error: (err) => {
        this.loader.hide();
        console.error('Error al generar expediente:', err);
      }
    });
  }

  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(/\s+/).filter(p => p);
    if (parts.length <= 1) return { firstName: parts[0] || '', lastName: '', secondLastName: '' };
    if (parts.length === 2) return { firstName: parts[0], lastName: parts[1], secondLastName: '' };
    if (parts.length === 3) return { firstName: parts[0], lastName: parts[1], secondLastName: parts[2] };
    // Para nombres con 4 o más partes, asumir que los primeros 2 son nombres y los últimos 2 son apellidos
    return {
      firstName: parts.slice(0, 2).join(' '),
      lastName: parts[parts.length - 2],
      secondLastName: parts[parts.length - 1]
    };
  }

  goToCall() {
    if (this.contactoDeTelefono && this.contactoDeTelefono !== '0') {
      window.open(`tel:${this.contactoDeTelefono}`, '_self');
    }
  }

  toggleAddresses() {
    this.showAllAddresses = !this.showAllAddresses;
  }

  goToAddAddress() {
    const navigationExtras: NavigationExtras = {
      queryParams: { returnUrl: this.router.url }
    };
    this.router.navigate(['/add-direccion'], navigationExtras);
  }

  selectAddress(dir: any) {
    this.selectedAddress = dir;
  }

  getSelectedAddressInfo(): string {
    if (!this.selectedAddress) {
      return '';
    }
    //return `${this.selectedAddress.streetNumber || ''} ${this.selectedAddress.interiorDepartament || ''}. ${this.selectedAddress.colony || ''}. ${this.selectedAddress.city || ''}`;
    return `
      ${this.selectedAddress.streetNumber || ''} 
      .Int ${this.selectedAddress.interiorDepartament || ''}, 
      ${this.selectedAddress.colony || ''},
      ${this.selectedAddress.cp || ''},
      ${this.selectedAddress.municipality || ''},
      ${this.selectedAddress.state || ''}`;
  }
}